'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function SidebarBrowseAtoz({ routes, bhcName }) {
  return h(
    '.sidebar-browse',
    {
      'data-bhw': 'BrowseByAtoz',
    },
    h(
      Translate,
      {
        tag: 'a',
        attrs: {
          class: 'sidebar-browse-button btn btn-invert',
          href: routes.all_brands.main,
          'data-bhc': bhcName,
        },
      },
      'modules.shared.SearchByAToZ'
    )
  );
}

module.exports = SidebarBrowseAtoz;
